import React from 'react';
import theme from './OptionGroupWizard.module.scss';
import { OptionWizardProduct } from './OptionGroupWizard.types';
import { ProjectFeeSet } from '@/types';
import { OptionGroupProductsEdit } from '../OptionGroupProductsEdit/OptionGroupProductsEdit';

export interface OptionGroupWizardProductsStepProps {
    projectId: number;
    value: OptionWizardProduct[];
    selectedFeeSet: ProjectFeeSet | null;
    onChange(newValue: OptionWizardProduct[]): void;
    absolutePricing?: boolean;
}

export const OptionGroupWizardProductsStep: React.FC<OptionGroupWizardProductsStepProps> = ({
    value,
    onChange,
    projectId,
    selectedFeeSet,
    absolutePricing,
}) => {
    return (
        <div className={theme.products}>
            <OptionGroupProductsEdit
                projectId={projectId}
                onChange={onChange}
                selectedFeeSet={selectedFeeSet}
                value={value}
                absolutePricing={absolutePricing}
            />
        </div>
    );
};
